module.exports = __webpack_public_path__ + "static/media/error-img.80c068b9.png";